import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children
}) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-173">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-174">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-cosmic-900/85 backdrop-blur-md" data-id="element-175" />

          {/* Panel */}
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[85vh] bg-cosmic-800 border border-amber-500/30 rounded-2xl shadow-[0_0_50px_rgba(245,197,66,0.15)] flex flex-col overflow-hidden" data-id="element-176">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-amber-500/20 bg-cosmic-900/50" data-id="element-177">
              <h2 id="modal-title" className="font-serif text-xl md:text-2xl text-amber-400 tracking-wide" data-id="element-178">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="text-gray-400 hover:text-amber-400 transition-colors p-1 rounded-md hover:bg-cosmic-700/50" data-id="element-179">
                <XIcon className="w-5 h-5" data-id="element-180" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 py-6 md:px-8 md:py-8 text-gray-300 font-body leading-relaxed text-base space-y-4" data-id="element-181">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};